import styled from 'styled-components';

// THEME
import {LargeSectionHeader} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';
export const AmenityInnerItemTextStylingSpan = styled.span(
  props => `
  margin-left: ${props.theme.spacing.small};
`,
);

export const AmenityInnerItemIconStylingSpan = styled.span(
  props => `
  margin-top: ${props.theme.spacing.small};
`,
);

export const AmenitiesOuterWrapper = styled.div(
  props => `
  width: 100%;
  margin: 2rem 0px;
`,
);

export const AmenitiesWrapper = styled.div(
  props => `

  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};

`,
);

export const AmenitiesHeaderStyled = styled(LargeSectionHeader)(
  props => `

  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;

`,
);

export const AmenitiesListBlock = styled.div(
  props => `

  padding: ${props.theme.spacing.xxlarge};
  border-radius: ${props.theme.misc.borderRadius.large};
  border-top-left-radius:0;
  border-top-right-radius:0;

`,
);

export const ShowHideLink = styled.div(
  props => `
    padding: 0rem 2.5rem 1.5rem 2.5rem;
    color: #2276E3;
    line-height: normal;
    font-size: 14px;
    font-weight: 600;
  `,
);

export const PopularAmenitiesTag = styled.span(
  props => `

  padding: ${props.theme.spacing.xsmall} ${props.theme.spacing.large} ${props.theme.spacing.xsmall} ${props.theme.spacing.small};
  background-image: linear-gradient(96deg, #1b9564, #39d546);
  border-radius: ${props.theme.misc.borderRadius.small};

`,
);

export const PopularAmenitiesTagTextStyled = styled.h3(
  props => `
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    display: inline;
  `,
);

export const AmentiesHorizontalListof4 = styled.ul(
  props => `

  list-style-type: none;
  display: flex;
  align-items: center;
  padding: ${props.theme.spacing.xxlarge} 0 0 0;
  font-size: ${props.theme.font.custom(16)};
`,
);

export const AmenityItemText = styled.span(
  props => `
    font-weight: 600;
    padding: 0 ${props.theme.spacing.large} 0 ${props.theme.spacing.base};
`,
);

export const CategorizedAmenitiesTableContainer = styled.div(
  props => `

  
  padding: ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge} ${
    props.theme.spacing.large
  } ${props.theme.spacing.xxlarge};
  background: ${props.theme.colors.goWhite.base};
  border-top: 0.1rem solid ${props.theme.colors.ash.dark};
  
  ${
    props.showMore
      ? `
    column-count: 4;
    column-gap: 20px;
  `
      : `
  display: flex;
  justify-content: space-around;
  `
  }
  `,
);

export const OneCateoryOfAmenitiesContainer = styled.div(
  props => `

  flex: 1;
  padding-bottom: ${props.theme.spacing.base};

`,
);

export const HeadingOneCategoryOfAmenitiesBlockStyled = styled.h3`
  ${textSizes.MediumW3}
  color: #222;
  margin-bottom: 12px;
`;

export const OneCategoryOfAmenitiesList = styled.ul`
  list-style-type: none;
`;
export const OneCategoryOfAmenitiesListItem = styled.li`
  ${textSizes.MediumW1}
  color: #717171;
  margin-bottom: 8px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #717171;
    position: absolute;
    left: 0;
    top: 8px;
  }
`;

export const HideAllAmenitiesTextContainer = styled.div(
  props => `
  padding: 0 0 ${props.theme.spacing.large} ${props.theme.spacing.xxlarge};
  color: ${props.theme.colors.goBrandBlue.base}
  font-size: ${props.theme.font.custom(16)};
`,
);

export const HideAllAmenitiesText = styled.a(
  props => `

  text-decoration: none;
  color: inherit;

`,
);
